import { render } from "./BathRequestCreate.vue?vue&type=template&id=03b64926&scoped=true"
import script from "./BathRequestCreate.vue?vue&type=script&lang=js"
export * from "./BathRequestCreate.vue?vue&type=script&lang=js"

import "./BathRequestCreate.vue?vue&type=style&index=0&id=03b64926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b64926"]])

export default __exports__